import { Component, h } from 'preact';
import { ChoicesButtonGroup } from './choices-button-group.component';
import { LabeledChoice } from '../../../../types/ui/form';

interface LabeledChoiceButtonGroupProps {
  choices: LabeledChoice[];
  value: any;
  disabled?: boolean;
  valid?: boolean;

  onSelect: (choice: any) => void;
}

export class LabeledChoiceButtonGroup extends Component<LabeledChoiceButtonGroupProps> {
  onSelect(label: string) {
    const selectedChoice = this.props.choices.find(choice => choice.label === label);

    if (selectedChoice) {
      this.props.onSelect(selectedChoice.value);
    }
  }

  render(props: LabeledChoiceButtonGroupProps) {
    const choices = props.choices;
    const selectedChoice = choices.find(choice => choice.value === props.value);

    return (
      <ChoicesButtonGroup
        choices={ choices.map(choice => choice.label) }
        // Don't get confused:
        // ChoicesButtonGroup can only select from a simple list of strings which
        // it uses as labels, so we give it labels.
        selectedChoice={ selectedChoice && selectedChoice.label }
        // When it tells us that the user selected something, we translate that
        // into the actual value here:
        onSelect={ label => this.onSelect(label) }
        valid={ props.valid }
        disabled={ props.disabled } />
    )
  }
}